// src/Components/Breadcrumb.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items }) => {

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
                {items.map((item, index) => (
                    <li 
                        key={index} 
                        className={`breadcrumb-item ${index === items.length - 1 ? 'active' : ''}`}
                        aria-current={index === items.length - 1 ? 'page' : undefined}
                    >
                        {index === items.length - 1 ? (
                            <span>{item.label}</span>
                        ) : (
                            <Link to={item.path} className="text-decoration-none">
                                {item.label}
                            </Link>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumb;